/* eslint-disable import/prefer-default-export */
import isObject from 'lodash/isObject';
import * as actionTypes from './actionTypes';
import store from '../router/store';
import { logout } from './authentication';

export function sendMessageToParent(data) {
  if (EMBEDDED) {
    window.parent.postMessage(data, '*');
  }
  return {
    type: actionTypes.IFRAME_MESSAGE_SENT,
    data,
  };
}

export function closeUspPage() {
  return {
    type: actionTypes.PARTNER_IFRAME_CLOSE_USP,
  };
}

export function onIframeMessage(event) {
  const { data } = event;

  if (isObject(data)) {
    if (DEBUG) {
      console.log('iframe sent message: ', event);
    }
    if (data.messageType === 'PARTNER_WEBSITE_PARAMS') {
      return {
        type: actionTypes.PARTNER_IFRAME_MESSAGE_RECEIVED,
        data: {
          ...data,
        },
      };
    } if (data.messageType === 'PARTNER_WEBSITE_EVENT') {
      if (data.eventType === actionTypes.LOGOUT) {
        store.dispatch(logout({ sendMessageToParent: true }));
      }
    } else if (data.messageType === 'CLOSE_USP_PAGE') {
      return closeUspPage();
    }
  }

  return {
    type: actionTypes.IFRAME_MESSAGE_RECEIVED,
  };
}
